export default "__VITE_ASSET__C6GA5DjM__"